export default {
  TICKET_LIST(state, item) {
    state.Tickets = item
  },
  setToken(state, data) {
    state.crmROLE = data.crmROLE
    state.crmservisAdresi = data.crmservisAdresi
    state.crmtokenId = data.crmtokenId
    state.crmfirmaAdi = data.crmfirmaAdi
    state.crmUserId = data.crmUserId
    state.crmUser = data.crmUser
  },
  ONAY_MAIL_MUSTERI(state, item) {
    state.onayMailMusteri = item;
  },
  ONAY_MAIL_ISLEM(state, item) {
    state.onayMailIslem = item;
  },
  ONAY_MAIL_FISNO(state, item) {
    state.onayMailFisNo = item;
  },
  EXCEL_YADIRILACAK_DATA(state, item) {
    state.excelYazdirilacakData = item;
  },

  MAL_KABUL_DETAY(state, item) {
    state.malKabulDetay = item;
  },
  MAL_KABUL_OLCULEN_DEGER(state, item) {
    state.malKabulOlculenDeger = item;
  },
  MAL_KABUL_SELECTABLE(state, item) {
    state.malKabulSelectable = item;
  },

  TAHSILAT_DETAY(state, item) {
    state.tahsilatRaporuDetay = item;
  },
  ITEM_ACTID(state, item) {
    state.ACTID = item;
  },
  ITEM_ACTNAME(state, item) {
    state.ACTNAME = item;
  },
  ITEM_ITEMLIST(state, item) {
    // console.log(item)
    state.ITEMLIST.push(Object.assign({}, item));
  },
  SATINALMA_TUR(state, item) {
    // console.log(item)
    state.satinalmaTur = item;
  },
  SAT_ROWDATA(state, item) {
    // console.log(item)
    state.satRowdata = item;
  },
  KAYITSAYISI_TUT(state, item) {
    state.KAYITSAYI = item;
  },
  STOKID_TUT(state, item) {
    state.stokId = item;
  },
  STOCKIDALTER_TUT(state, item) {
    state.STOCKIDALTER = item;
  },
  SEPETACTNAME_TUT(state, item) {
    state.sepetACTNAME = item;
  },
  SEPETACTID_TUT(state, item) {
    state.sepetACTID = item;
  },
  SEPETSTOKID_TUT(state, item) {
    state.sepetSTOKID = item;
  },
  STOKSTOCKNAME_TUT(state, item) {
    state.stokSTOCKNAME = item;
  },
  STOKSTOCKID_TUT(state, item) {
    state.stokSTOCKID = item;
  },
  STOKSTOCKNO_TUT(state, item) {
    state.stokSTOCKNO = item;
  },
  SATINALMA_ACTID(state, item) {
    state.satinalmaPlanlamaACTID = item;
  },
  SATINALMA_FIYAT(state, item) {
    state.satinalmaPlanlamaFiyatVal = item;
  },
  IADEARIZA_KALEM_LIST(state, item) {
    state.iadeArizaKalemList = item;
  },
  IADEARIZA_DETAY(state, item) {
    state.tahsilatRaporuDetay = item;
  },
  SATINALMA_IND1(state, item) {
    state.planlamaIND1 = item;
  },
  SATINALMA_IND2(state, item) {
    state.planlamaIND2 = item;
  },
  SATINALMA_IND3(state, item) {
    state.planlamaIND3 = item;
  },
  SATINALMA_CARI(state, item) {
    state.planlamaCariId = item;
  },
  CARI_EKSTRE_LIST(state, item) {
    state.cariTahilatEkstreList = item;
  },
  CARI_TAHSILAT_GECVADE(state, item) {
    state.cariTahsilatGecVadeNedeni = item;
  },
  CARI_TAHSILAT_GECVADE_VALIDATE(state, item) {
    state.cariTahsilatNedenValidate = item;
  },
  CARI_EKSTRE_BASLANGIC(state, item) {
    state.cariTahsilatEkstreBaslangic = item;
  },
  CARI_EKSTRE_BITIS(state, item) {
    state.cariTahsilatEkstreBitis = item;
  },
  CARI_EKSTRE_TOPLAMBORC(state, item) {
    state.cariEkstreToplamBorc = item;
  },
  CARI_EKSTRE_TOPLAMALACAK(state, item) {
    state.cariEkstreToplamAlacak = item;
  },
  CARI_EKSTRE_TOPLAMBAKIYE(state, item) {
    state.cariEkstreToplamBakiye = item;
  },
  ZIYARET_RAPORU_LISTESI(state, item) {
    state.ziyaretRaporuListesi.push(item);
  },
  FATURASIL_BUTON_VALIDATE(state, item) {
    state.faturaSilButonValidate = item;
  },
  REMOVE_ITEM(state, itemId) {
    const ItemIndex = state.ITEMLIST.findIndex(p => p.id === itemId);
    console.log(ItemIndex);
    state.ITEMLIST.splice(ItemIndex, 1);
  },
  UPDATE_ITEM_ISLEM(state, payload) {
    const ItemIndex = state.ITEMLIST.findIndex(p => p.id === payload.id);
    state.ITEMLIST[ItemIndex].islemselected = payload.islemselected;
  },
  UPDATE_ITEM_BANKA(state, payload) {
    const ItemIndex = state.ITEMLIST.findIndex(p => p.id === payload.id);
    state.ITEMLIST[ItemIndex].bankaText = payload.bankaText;
  },
  UPDATE_ITEM_CEK(state, payload) {
    const ItemIndex = state.ITEMLIST.findIndex(p => p.id === payload.id);
    state.ITEMLIST[ItemIndex].CekNo = payload.CekNo;
  },
  UPDATE_ITEM_TUTAR(state, payload) {
    const ItemIndex = state.ITEMLIST.findIndex(p => p.id === payload.id);
    state.ITEMLIST[ItemIndex].tutar = payload.tutar;
  },
  UPDATE_ITEM_VADE(state, payload) {
    const ItemIndex = state.ITEMLIST.findIndex(p => p.id === payload.id);
    state.ITEMLIST[ItemIndex].vade = payload.vade;
  },
  UPDATE_ITEM_GUN(state, payload) {
    const ItemIndex = state.ITEMLIST.findIndex(p => p.id === payload.id);
    state.ITEMLIST[ItemIndex].gun = payload.gun;
  },
  UPDATE_ITEM_DISABLE(state, payload) {
    const ItemIndex = state.ITEMLIST.findIndex(p => p.id === payload.id);
    state.ITEMLIST[ItemIndex].disable = payload.disable;
  } /*
      this.$store.commit("account/UPDATE_ITEM_ISLEM", arguman.islemselected);
        this.$store.commit("account/UPDATE_ITEM_BANKA", arguman.bankaText);
        this.$store.commit("account/UPDATE_ITEM_CEK", arguman.CekNo);
        this.$store.commit("account/UPDATE_ITEM_TUTAR", arguman.tutar);
        this.$store.commit("account/UPDATE_ITEM_VADE", arguman.vade);
        this.$store.commit("account/UPDATE_ITEM_GUN", arguman.gun);
        this.$store.commit("account/UPDATE_ITEM_DISABLE", arguman.disable);
*/
  /*const arguman = {
        islemselected: this.items[index].islemselected,
        bankaText: this.items[index].bankaText,
        CekNo: this.items[index].CekNo,
        tutar: this.items[index].tutar,
        vade: this.items[index].vade,
        gun: this.items[index].gun,
        disable: true,
      };*/
};
